module.exports = __webpack_public_path__ + "c4dab12f57151fa5515525da2c7d4790.svg";